import useAxios from "../../hooks/useAxios";

const useCategorizedPositionService = () => {
  const { response, loading, error, fetchData } = useAxios();
  const { fetchData: fetchRemove } = useAxios();
  const { fetchData: fetchAdd } = useAxios();

  const getSubordinate = async (id) => {
    if (!id) return;
    await fetchData({
      url: `/admin/position/${id}/subordinate`,
      method: "GET",
    });
  };

  const removeSubordinate = async (id) => {
    if (!id) return;
    await fetchRemove({
      url: `/admin/position/${id}/remove-approver`,
      method: "POST",
    });
  };

  const addSubordinate = async (approverId, positionIds) => {
    if (!approverId || !Array.isArray(positionIds) || positionIds.length === 0)
      return;

    await fetchAdd({
      url: `/admin/position/assign-approver/${approverId}`,
      method: "POST",
      data: { position_ids: positionIds },
    });
  };

  return {
    response,
    error,
    loading,
    getSubordinate,
    removeSubordinate,
    addSubordinate,
  };
};

export default useCategorizedPositionService;
